import { inflate } from 'pako';

/**
 * Decompresses a Base64 encoded compressed string.
 * @param str The compressed Base64 encoded string to decompress.
 * @returns The decompressed JSON object, or null if the input string is falsy.
 */
export function decompress(str: string) {
  if (!str) {
    return null;
  }
  const strData = window.atob(str);
  const charData = strData.split('').map((x) => x.charCodeAt(0));
  const binData: Uint8Array = new Uint8Array(charData);
  return JSON.parse(inflate(binData, { to: 'string' }));
}
